import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { getFacultyNavSections } from '../components/Sidebar/roleNavConfig';
import { buildDomainSections } from '../components/Sidebar/buildDomainSections';
import { FACULTY_ACTIVITY_FEED_PATH, FACULTY_WORKSPACE_OVERVIEW_PATH } from '../constants/facultyNav';
import { isCbcFaculty, canAccessTeaching } from '../utils/facultyRole';

const FacultyLayout = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const baseNavSections = useMemo(() => getFacultyNavSections({ user }), [user]);
  const sections = useMemo(() => buildDomainSections(baseNavSections, 'faculty'), [baseNavSections]);
  const isWideCoachingHub = /^\/faculty\/student\/[^/]+$/.test(pathname);
  const shell = useMemo(() => {
    const isCbc = isCbcFaculty(user);
    const hasCodingNav = canAccessTeaching(user);
    return {
      homePath: '/faculty/dashboard',
      workspacePath: hasCodingNav ? FACULTY_WORKSPACE_OVERVIEW_PATH : '/faculty/dashboard',
      profilePath: '/faculty/profile',
      projectBasePath: '/faculty/project',
      codingRoot: hasCodingNav ? '/faculty' : null,
      codingActivityPath: isCbc ? FACULTY_ACTIVITY_FEED_PATH : null,
    };
  }, [user]);

  /** Absolute path — sidebar brand always goes to the faculty teaching workbench. */
  const brandPath = '/faculty/dashboard';

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout
        brandPath={brandPath}
        sections={sections}
        contentMaxWidth={isWideCoachingHub ? false : 'lg'}
      >
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default FacultyLayout;
